import FormattedMessage from 'I18n/components/FormattedMessage';
import { RefreshEligibilityButton } from '../components/RefreshEligibilityButton';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function MoveTicketText({
  onRefresh,
  isRefreshing = false
}) {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: 'app.moveToSupportCard.body'
    }), /*#__PURE__*/_jsx(View, {
      marginInlineStart: "100",
      as: "span",
      children: /*#__PURE__*/_jsx(RefreshEligibilityButton, {
        "data-test-id": "refresh-eligibility-button",
        isRefreshing: isRefreshing,
        onRefresh: onRefresh
      })
    })]
  });
}